import { FaShieldAlt, FaLock, FaHeadset } from "react-icons/fa";
import images from "./images";

const About = {
    sub: "About Us",
    heading: "Protecting Your Future with Advanced Solutions",
    description: "Our mission is to provide cutting-edge CCTV and security systems that ensure the safety of your home and business. We aim to innovate and deliver reliable, scalable security solutions.",
    points: [
        { 
            icon: <FaLock />, 
            title: "Security Solutions", 
            content: "We offer CCTV installation, alarm systems, and 24/7 monitoring to keep you safe." 
        },
        { 
            icon: <FaHeadset />, 
            title: "Customer Support", 
            content: "Our expert team is always available to assist with installation and maintenance." 
        }
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        alt1: "CCTV-Image-1",
        alt2: "CCTV-Image-2",
        experience: {
            years: "30+ years",
            title: "of experience",
            icon: <FaShieldAlt />
        }
    },
    button: {
        text: "Discover More",
        link: "About-us"
    }
};

export default About;